module.exports = __webpack_public_path__ + "static/img/technician1.16de2c6a.png";